import computed from './computed'
import components from './components'
import data from './data'
import methods from './methods'
import mounted from './mounted'
import props from './props'

export default {
  components,
  computed,
  data,
  methods,
  mounted,
  props
}



// WEBPACK FOOTER //
// ./src/app/patient/loading-page/components/schedule/resources/index.js